import { useStore } from "effector-react";
import { useEffect } from "react";
import CourseCover from "../../../../shared/UI/CourseCover";
import s from "./styles.module.sass";
import CourseContentInfo from "../parts/CourseContentInfo";
import CourseActions from "../parts/CourseActions";
import { initCourseDetailsCard } from "../../model/private";
import { getPurchasedCoursesParams } from "../../model/constants";
import { useEvent } from "effector-react/scope";
import { $course } from "@features/Course/model/public";
import { $isAuth } from "../../../../process/authProcess/model/public";
import { calcFinalPrice } from "@shared/functions/calcFinalPrice";
import { roundNumber } from "@shared/functions/roundNumber";
import formatNumberToCurrency from "@shared/functions/formatNumberToCurrency";

type CourseDetailsCardProps = {
	isPreviewMode: boolean;
};

const CourseDetailsCard = ({ isPreviewMode }: CourseDetailsCardProps) => {
	const isAuth = useStore($isAuth);
	const course = useStore($course);
	const initCourseDetailsCardEvent = useEvent(initCourseDetailsCard);

	useEffect(() => {
		if (isAuth) {
			initCourseDetailsCardEvent(getPurchasedCoursesParams);
		}
	}, []);

	const price = course ? roundNumber(course?.cost) : 0;
	const priceWithDiscount = course
		? calcFinalPrice({
				cost: course.cost,
				discount: course?.discount,
		  })
		: 0;

	return (
		<div className={s.wrapper}>
			{course ? (
				<div className={s.coverAndCourseInfoWrapper}>
					<div className={s.courseCoverWrapper}>
						<CourseCover
							id={course.id}
							cover={course?.coverUrl}
							promo={course.teaserUrl ?? ""}
							courseTitle={course.title}
						/>
					</div>
					<div className={s.courseInfoAndPriceWrapper}>
						<CourseContentInfo sections={course.sections} />
						<div className={s.priceBlock}>
							<p className={s.currentPrice}>{formatNumberToCurrency(priceWithDiscount)}</p>
							{course.discount !== 0 && <s className={s.oldPrice}>{formatNumberToCurrency(price)}</s>}
						</div>
					</div>
				</div>
			) : null}
			<CourseActions isPreviewMode={isPreviewMode} />
		</div>
	);
};

export default CourseDetailsCard;
